/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type app_v1_external_assets_CreateExternalAsset = {
    account_id: string;
    acquisition_date?: string | null;
    asset_type: app_v1_external_assets_CreateExternalAsset.asset_type;
    correlation_proxy?: string | null;
    cost_basis?: number | null;
    currency: string;
    estimated_tax_percent?: number | null;
    expected_return?: number | null;
    interest_rate?: number | null;
    liquidity?: app_v1_external_assets_CreateExternalAsset.liquidity | null;
    name: string;
    notes?: string | null;
    ownership_share_percent?: number | null;
    price_per_unit?: number | null;
    properties?: Record<string, any> | null;
    quantity?: number | null;
    symbol?: string | null;
    total_value?: number | null;
    valuation_date?: string | null;
    volatility?: number | null;
};

export namespace app_v1_external_assets_CreateExternalAsset {

    export enum asset_type {
        STOCK = 'stock',
        REAL_ESTATE = 'real_estate',
        CRYPTO = 'crypto',
        SAVINGS_ACCOUNT = 'savings_account',
        OTHER = 'other',
        PRIVATE_SECURITIES = 'private_securities',
        VEHICLES = 'vehicles',
        PRECIOUS_METALS = 'precious_metals',
        COLLECTIBLES = 'collectibles',
        LIABILITY = 'liability',
    }

    export enum liquidity {
        HIGH = 'high',
        MEDIUM = 'medium',
        LOW = 'low',
        ILLIQUID = 'illiquid',
    }


}

